import styles from './styles'

window.initContactMap = () => {
	const google = window.google,
		mapElement = document.getElementById('contact-map'),
		lat = parseFloat(mapElement.dataset.lat),
		lng = parseFloat(mapElement.dataset.lng)

	let map = new google.maps.Map(mapElement, {
		zoom: 17,
		styles: styles,
		center: {
			lat: lat,
			lng: lng
		}
	})

	var mapMarker = {
    path: 'M14.37,24.73c.07,0,.07-.08.15-.08s.08.08.16.08c2.06-1,7.75-4.5,7.75-11a7.91,7.91,0,0,0-15.81,0C6.62,20.23,12.39,23.7,14.37,24.73Zm.15-14.07a3.17,3.17,0,1,1-3.16,3.17A3.18,3.18,0,0,1,14.52,10.66Z',
    fillColor: '#ffc709',
    fillOpacity: 1,
    scale: 3.5,
    strokeColor: '#ffc709',
    strokeWeight: 0,
    anchor: new google.maps.Point(15, 20),
  }

	new google.maps.Marker({
		position: new google.maps.LatLng(lat, lng),
		map: map,
		title: mapElement.dataset.markerLabel,
		icon: mapMarker
	})

}




// WEBPACK FOOTER //
// ./scripts/lib/contact-map/contact-map.js